import { theme, setTheme } from '../theme';



setTheme(require('../../src/modifiers/common').common(theme));
